import { VariableType } from 'json-to-graphql-query';

export const EventsVariables = {
  start: 'DateScalar!',
  end: 'DateScalar!'
};

export const EventsArgs = {
  start: new VariableType('start'),
  end: new VariableType('end')
};
